import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { CookieProvider } from './cookie.provider';
import { AUTH_CONFIG, AuthConfig } from '~auth/providers/auth.provider';
import { STORAGE } from '~auth/providers/token.provider';

@Injectable()
export class AoCookieProvider extends CookieProvider {
  PING_TIMER = 58 * 60;

  constructor(private http: HttpClient,
    cookieService: CookieService, @Inject(AUTH_CONFIG) authConfig: AuthConfig, @Inject(STORAGE) private storage: Storage) {
    super(cookieService, authConfig);
  }

  clearStorage() {
    this.storage.removeItem(this.authConfig.token);
    this.storage.removeItem(this.authConfig.token + 'Profile');
    this.storage.removeItem(this.authConfig.cookie);
  }

  isAuthenticated() {

    if (!this.authConfig.useCookie) {
      return true;
    }

    const isCookieExists = this.cookieService.check(this.authConfig.cookie);
    const cookie = this.cookieService.get(this.authConfig.cookie);
    const storageCookie = this.storage.getItem(this.authConfig.cookie);

    if (!isCookieExists) {
      this.clearStorage();
      return false;
    }

    if (!storageCookie && isCookieExists) {
      this.storage.setItem(this.authConfig.cookie, cookie);
      return true;
    } else if (storageCookie !== cookie) {
      this.clearStorage();
      return true;
    }

    return storageCookie === cookie;
  }

  ping(): Observable<boolean> {
    return this.http.post(`${this.authConfig.aoUrl}/app/auth`, null, {
      withCredentials: true,
      observe: 'response',
      responseType: 'text'
    })
      .take(1)
      .map(res => res.status === 200)
      .catch(() => Observable.of(false));
  }

  signOut(): Observable<boolean> {
    this.clearStorage();
    if (!this.authConfig.useCookie) return Observable.of(true);

    return this.http.get(`${this.authConfig.aoUrl}/j_spring_security_logout`, { withCredentials: true })
      .catch(error => {
        try {
          this.cookieService.delete(this.authConfig.cookie, '/', ".realpage.com");
        } catch (e) {
          console.log('Failed to delete cookie');
        }
        return Observable.of(true);
      })
      .map((resp) => {
        return true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/providers/ao-cookie.provider.ts